import * as React from "react";
import { Card } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { tagLinkUrlPrefixes } from "../../services/utils";
import { TagLinksTable } from "../../components/detail/tagLinksTable";
import { ServiceAccount } from "../../schema/types/serviceAccount/entity";
import { CpFormItem } from "../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../gvc/testNewForm/CpErrorWarning";
import { CpLabelDirtyIndicator } from "../gvc/testNewForm/CpLabelDirtyIndicator";
import { CpTextArea } from "../gvc/testNewForm/CpTextArea";
import { FormLabel } from "../../components/antd/form/FormLabel";

interface Props {
  serviceAccount: ServiceAccount;
}
export const Summary: React.FC<Props> = ({ serviceAccount }) => {
  const hasTagLinks =
    Object.entries(serviceAccount.tags || {}).filter(([_, value]) =>
      tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)),
    ).length > 0;

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardContent>
            <CpFormItem>
              <CpLabel name={`description`}>
                <FormLabel>Description</FormLabel>
                <CpLabelDirtyIndicator name={`description`} />
              </CpLabel>
              <CpTextArea autoSize name={`description`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`description`} />
            </CpFormItem>
            {hasTagLinks ? (
              <TagLinksTable
                tableId="serviceaccount-info-tag-links"
                tags={Object.entries(serviceAccount.tags || {})
                  .filter(([_, value]) => tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)))
                  .map(([key, value]) => ({ key, value }))}
                styles={{ container: { width: "100%" }, header: { marginBottom: 0 } }}
              />
            ) : null}
          </CardContent>
        </Card>
      </div>
    </>
  );
};
